export class BasePacket {
  public deviceNumber: string;
  public receiverNumber: string;
  constructor(data: any) {
    this.readDeviceNumber(data);
  }

  private readDeviceNumber(data: any) {
    this.deviceNumber = data.readUInt32BE(9).toString();
    this.receiverNumber = data.readUInt32BE(4);
  }
}
